import React from 'react';
import { Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { ToastContainer } from 'react-toastify';
import { LastLocationProvider } from 'react-router-last-location';

import { dataProvider } from './store/dataProvider';
import { RouteProvider } from './routes/routeProvider';

import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import './style/main.scss';
import { QueryParamProvider } from 'use-query-params';

export const history = createBrowserHistory();
export const store = dataProvider(history);

/**
 * Добро пожаловать в ад)))
 * Код писался максимально быстро и не прям профи, поэтому да
 * Насчёт варнингов на зависимости в хуках, ну вот так получилось)
 */

const App = () => {
  return (
    <>
      <Provider store={store}>
        <Router history={history}>
          <QueryParamProvider ReactRouterRoute={Route}>
            <LastLocationProvider>
              <RouteProvider />
            </LastLocationProvider>
          </QueryParamProvider>
        </Router>
      </Provider>
      <ToastContainer />
    </>
  );
};

export { App };
